import {useFormik} from 'formik'
import {KTIcon} from '../../../../../_metronic/helpers'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import {BASE_URL} from '../../../config'
import toast from 'react-hot-toast'
import useLinkList from '../../../../hooks/useLinkLIst'
import ReactSelectBox from '../../../../utils/components/ReactSelectBox'
import {useEffect} from 'react'
import {initSubMenuFormValues, ISubmenu, ISubMenuFormValues} from '../_model'
import useMenuList from '../../../../hooks/useMenuList'
import {ISelectOption} from '../../../../utils/core/_model'

const CREATE_SUB_MENU_URL = `${BASE_URL}/api/protect/createSubmenu`
const UPDATE_SUB_MENU_URL = `${BASE_URL}/api/protect/updateSubmenu`

type Props = {
  selectedSubmenu: ISubmenu | undefined
  onResetSelect: () => void
}

const SubMenuForm = ({selectedSubmenu, onResetSelect}: Props) => {
  const queryClient = useQueryClient()
  const {optionsLink: linkOptions} = useLinkList()
  const {options: menus, optionsMenu: menuOptions} = useMenuList()

  const {mutateAsync: submenuSubmit} = useMutation({
    mutationFn: async (sendvalue: Partial<ISubMenuFormValues>) => {
      if (selectedSubmenu) {
        await axios.put(UPDATE_SUB_MENU_URL, {...sendvalue, idSubmenu: selectedSubmenu.id_submenu})
        onResetSelect()
      } else {
        await axios.post(CREATE_SUB_MENU_URL, sendvalue)
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfull')
      queryClient.invalidateQueries(['submenuItemList'])
      resetForm()
    },
  })

  const formik = useFormik({
    initialValues: initSubMenuFormValues,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        console.log(values)
        const {link, menuName, ...sendvalues} = values
        await submenuSubmit(sendvalues)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onSelectLink = (id: number) => formik.setFieldValue('linkId', id)

  const onSelectMenu = (id: number) => {
    formik.setFieldValue('idMenu', id)
    console.log(id)
  }

  const resetForm = () => {
    formik.resetForm()
  }

  const getNameById = (arr: ISelectOption[], id: number): string => {
    let name = ''
    const selected = arr.find((el) => el.id === id)

    if (selected) {
      name = selected.value
    }

    return name
  }

  useEffect(() => {
    resetForm()
    if (selectedSubmenu) {
      formik.setValues({
        submenuName: selectedSubmenu.submenu_name,
        link: getNameById(linkOptions, selectedSubmenu.link_id),
        linkId: selectedSubmenu.link_id,
        icon: selectedSubmenu.icon,
        menuName: getNameById(menuOptions, selectedSubmenu.id_menu),
        idMenu: selectedSubmenu.id_menu,
      })
    }
  }, [selectedSubmenu])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Submenu Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onResetSelect}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='row row-cols-1'>
                {/* Menu Name */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Submenu Name</label>

                    <input
                      {...formik.getFieldProps('submenuName')}
                      placeholder='Enter name'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>

                {/* Link ID */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Link</label>

                    <ReactSelectBox
                      formik={formik}
                      fieldValue='link'
                      placeholder='Select link'
                      setSelect={onSelectLink}
                      options={linkOptions}
                    />
                  </div>
                </div>

                {/* Menu */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Parent Menu</label>

                    <ReactSelectBox
                      formik={formik}
                      fieldValue='menuName'
                      placeholder='Select parent menu'
                      setSelect={onSelectMenu}
                      options={menuOptions}
                    />
                  </div>
                </div>

                {/* Menu Icon */}
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Icon</label>

                    <input
                      {...formik.getFieldProps('icon')}
                      placeholder='Enter icon'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>
              </div>
              <div className='text-center pt-15'>
                <button
                  type='reset'
                  className='btn btn-light me-3 border border-gray-600'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  CLOSE
                </button>

                <button
                  type='submit'
                  className='btn btn-primary me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SubMenuForm
